export const CHAT_AGENT_VERSION_V2 = 'chat-agent-v2';
